import $ from 'jquery';

import Section from "../Section";
import MobileMenu from '../global/MobileMenu';
import Menu from '../global/Menu';
import Localization from '../global/Localization';
import { CART_UPDATE_EVENT } from '../ThemeBase';

export default class Header extends Section {
  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   * @param {boolean} pageLoad
   */
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.$element = $(this.element);

    Array.prototype.forEach.call(
      this.element.querySelectorAll('.js-drawer-open-right-link'),
      (el) => el.addEventListener('click', this.onCartButtonClick),
    );
    this.element.querySelector('.js-drawer-open-left-link').addEventListener('click', this.onMobileMenuButtonClick)
    this.mobileMenu = new MobileMenu(theme, this.element.querySelector('.drawer--left'));

    document.documentElement.addEventListener(CART_UPDATE_EVENT, this.onCartUpdate);

    // Close mobile menu on overlay click
    this.element.querySelector('#NavDrawerOverlay').addEventListener('click', () => this.theme.toggleLeftDrawer(false));

    this.loadAccessibleMenu();
    if (this.element.dataset.headerSticky === 'true') {
      this.loadStickyHeader();
    }
    this.loadLogIn();
    this.loadSearchDrawer();
    this.menu = new Menu(this, element);
    this.localization = new Localization(theme, element);
  }

  onCartUpdate = (e) => {
    Array.prototype.forEach.call(
      document.querySelectorAll('.cart-item-count-header--quantity'),
      (el) => {
        el.textContent = e.detail.cart.item_count;
      },
    );
    const price = this.theme.formatMoney(e.detail.cart.total_price);
    Array.prototype.forEach.call(
      document.querySelectorAll('.cart-item-count-header--total'),
      (el) => {
        el.innerHTML = price;
      },
    );
  }

  onCartButtonClick = (e) => {
    e.preventDefault();
    this.theme.toggleRightDrawer('cart');
  }

  onMobileMenuButtonClick = (e) => {
    e.preventDefault();
    this.mobileMenu.toggle();
  }

  loadLogIn = () => {
    const button = this.element.querySelector('.log-in-button');
    if (button) {
      button.addEventListener('click', this.onLogIn);
    }
  }

  onLogIn = (e) => {
    e.preventDefault();
    this.theme.toggleRightDrawer('login', true);
  }

  loadSearchDrawer = () => {
    const search = this.element.querySelector('.search-button');
    if(search) {
      search.addEventListener('click', this.onSearch);
    }
  }

  onSearch = (e) => {
    e.preventDefault();
    this.theme.toggleRightDrawer('search', true);
  }

  loadAccessibleMenu = () => {
    this.$element.find(".site-nav").addClass("js");
    this.$element.find(".site-nav li a").focus(function() { // main nav anchor focus
      $(this).parent().children("ul").fadeIn();
    });
    this.$element.find(".site-nav li li a").off(); // unbind hide drop downs from sub nav anchors

    const self = this;
    this.$element.find('.mobile-nav__link').on('click', function () {
      const a = /** @type {HTMLAnchorElement} */ (this);
      if (a.href && a.href.split('#')[0] === window.location.href.split('#')[0]) {
        // Anchor on same page - just close the drawer
        self.theme.toggleLeftDrawer(false);
      }
    });
  }

  // Sticky page header
  loadStickyHeader = () => {
    // We need to apply sticky to child of element that is being scrolled, it this case it's whole `shopify-section`
    const headerWrapper = this.element.closest('.shopify-section');
    headerWrapper.classList.add('sticky-header');

    const observer = new IntersectionObserver(
      ([e]) => {
        e.target.classList.toggle('sticked', e.intersectionRatio < 1)
      },
      {
        threshold: [1],
      },
    );

    observer.observe(headerWrapper);
  }

  onBlockSelect = ({ element }) => {
    // Open mega menu and make overlay force-hovered
    if (element.dataset.megaMenuBlockId) {
      this.$element.find('[data-mega-menu-block-id=' + element.dataset.megaMenuBlockId + ']').closest('li.mega-menu').addClass('force-open');
      this.$element.find('.overlay-header').addClass('force-hover');
    }
  }

  onBlockDeselect = () => {
    // Close mega menu and make overlay non-hovered
    this.$element.find('li.mega-menu.force-open').removeClass('force-open');
    this.$element.find('.overlay-header').removeClass('force-hover');
  }
}
